
import { Vue, Component } from 'vue-property-decorator';
import { Toast, Popup, Dialog, Picker, RadioGroup, Radio } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { getDetail, save, getBaseInfo } from '../api/index';
import Uploader from '@/components/next/NewUploader.vue';
import { FileType } from '@/common/ts/enum';
import qs from 'qs';
Vue.use(Popup).use(Picker).use(Dialog).use(Toast).use(RadioGroup).use(Radio);
@Component({
  components: {
    Uploader,
  },
})
export default class Home extends Vue {
    showSumbitPopup: boolean = false;
    showSave: boolean = false;
    showMessage: boolean = false;
    name: any = "";
    workType: any = "媒体记者证";
    company: any = "";
    job: any = "";
    nationality: any = "";
    certificateType: any = "";
    certificate: any = [];
    workTypeText: any = "身份证";
    isAttend: any = "否";
    phone: any = "";
    cover: any = [];
    showPopupSumbitButton: boolean = true;
    showWorkType: boolean = false;
    workOptions: any = ['身份证','记者证'];
    presetFilesImages: any = [];
    nowTime: Date = new Date();
    startTime: Date = new Date();
    endTime: Date = new Date();
    showTime: any = "";
    showUpdate: any = true;
    async created() {
        const unionid = localStorage.getItem('unionid') as string;
        if (!isWeiXin()) {
            Toast('请在微信参与报名');
            return;
        }else {
          if(!unionid || unionid === 'undefined'){
            this.WechatLogin();
          }
        }
        const ret: any = await getBaseInfo();
        if (ret.code === 200){
            this.endTime = new Date(ret.data.endTime*1000);
            this.nowTime = new Date()
            this.showTime =  `${this.endTime.getFullYear()}年${(this.endTime.getMonth() + 1).toString().padStart(2, '0')}月${this.endTime.getDate().toString().padStart(2, '0')}日`;
            if (this.nowTime > this.endTime){
                this.showUpdate = false;
            }
        }
        const res: any = await getDetail(unionid);
        if(res.code === 200){
            this.showMessage = true;
            this.showSave = false;
            this.name = res.data.name;
            this.workType = res.data.work_type;
            this.company = res.data.company;
            this.job = res.data.job;
            this.nationality = res.data.nationality;
            this.certificateType = res.data.certificate_type;
            this.certificate = res.data.certificate;
            this.isAttend = res.data.is_attend;
            this.phone = res.data.phone;
            this.cover = res.data.cover.split(',');
            this.workTypeText = res.data.certificate_type;
            this.presetFilesImages = [
                {
                    cover: res.data.cover,
                    path: res.data.cover,
                    type: FileType.Image,
                },
            ];
        }else{
            this.showSave = true;
        }
    }

    onSumbitOne(){
        const unionid = localStorage.getItem('unionid') as string;
        if (!isWeiXin()) {
            Toast('请在微信参与报名');
            return;
        }else {
          if(!unionid || unionid === 'undefined'){
            this.WechatLogin();
          }
        }
        
        if (!this.formValidator()) {
            return;
        }
        const nums = (this.$refs.uploader as Uploader).presetFiles.length
        const num = (this.$refs.uploader as Uploader).displayImages.length
        if (nums == 0){
            if(num == 0){
                Toast('请上传登记照');
                return false;
            }
        }
        this.showSumbitPopup = true;
    }

    async onSumbit(){
        const unionid = localStorage.getItem('unionid') as string;
        if (!isWeiXin()) {
            Toast('请在微信参与报名');
            return;
        }else {
          if(!unionid || unionid === 'undefined'){
            this.WechatLogin();
          }
        }
        
        if (!this.formValidator()) {
            return;
        }
        const nums = (this.$refs.uploader as Uploader).presetFiles.length
        const num = (this.$refs.uploader as Uploader).displayImages.length
        if (nums == 0){
            this.showPopupSumbitButton = false;
            if(num == 0){
                Toast('请上传登记照');
                this.showPopupSumbitButton = true;
                return false;
            }
        }
        if(num > 0){
            this.cover = (await (
                this.$refs.uploader as Uploader
            ).uploadToOss()) as string[];
        }
        let newCover = "";
        if(this.cover){
            newCover = this.cover.join(',');
        }
        const data = {
            unionid: unionid,
            name: this.name,
            workType: this.workType,
            company: this.company,
            job: this.job,
            nationality: this.nationality,
            certificateType: this.workTypeText,
            certificate: this.certificate,
            is_attend: this.isAttend,
            phone: this.phone,
            cover: newCover,
        };
        this.showPopupSumbitButton = false;
        const res: any = await save(data);
        if(res.code === 200){
            Toast.success(res.msg);
            setTimeout(() => {
                window.location.reload();
            },1000)
        }else{
            Toast.success(res.msg);
            this.showPopupSumbitButton = true;
        }
    }

    back(){
        this.$router.push(`home`);
    }

    onchangeLogin(){
        const unionid = localStorage.getItem('unionid') as string;
        if (!isWeiXin()) {
            Toast('请在微信参与报名');
            return;
        }else {
          if(!unionid || unionid === 'undefined'){
            this.WechatLogin();
          }
        }
    }

    formValidator() {
        if (!this.name) {
        Toast('请填写姓名');
        return false;
        } else if (!this.workType) {
        Toast('请填写申请证件类型');
        return false;
        } else if (!this.company) {
        Toast('请填写单位');
        return false;
        } else if (!this.job) {
        Toast('请填写职务');
        return false;
        } else if (!this.nationality) {
        Toast('请填写国籍');
        return false;
        } else if (!this.workTypeText) {
        Toast('请选择证件类型');
        return false;
        } else if (!this.certificate) {
        Toast('请填写证件号码');
        return false;
        } else if (!this.phone) {
        Toast('请填写联系电话');
        return false;
        } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
        Toast('请填写正确的电话');
        return false;
        } else if (!this.isAttend) {
        Toast('请选择是否参加开幕式');
        return false;
        } else {
        return true;
        }
    }

    WechatLogin() {
        const { code, source } = qs.parse(location.search, {
            ignoreQueryPrefix: true,
        });
        if (isWeiXin() && !code) {
             const appId = 'wx1949ed4a473b87ed';
              location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
              location.href,
            )}`;
        }
    }

    onConfirm(d: string, i: number) {
        this.workTypeText = d;
        this.togglePicker();
    }
    onCancel() {
        this.togglePicker();
    }
    togglePicker() {
        this.showWorkType = !this.showWorkType;
    }
    showSaveDiv(){
        this.showMessage = false;
        this.showSave = true;
    }
    closeSumbit(){
        this.showSumbitPopup = false;
    }
}
